export const commentEndpoints = {
  createRequestComment: { method: 'post', path: '/request' },
  editRequestComment: { method: 'post', path: '/request/{commentId}' },
  deleteRequestComment: { method: 'post', path: '/request/{commentId}/delete' },
  createComment: { method: 'post', path: '/entity/{entity}/{entityId}' },
  listComments: { method: 'get', path: '/entity/{entity}/{entityId}' },
  updateComment: { method: 'post', path: '/entity/{entity}/{entityId}/update' },
  deleteComment: { method: 'post', path: '/entity/{entity}/{entityId}/delete' },
  getMentionTargets: { method: 'get', path: '/mention-targets' },
  getRequestComments: { method: 'get', path: '/request-comments/{requestId}' },
  getRequestThread: { method: 'get', path: '/request-thread' },
  getEntityThread: { method: 'get', path: '/entity-thread/{entity}/{entityId}' },
  resolveAmendments: { method: 'post', path: '/resolve-amendment-request' },
  getMentions: { method: 'post', path: '/mentions' },
  markMentionsResolved: { method: 'post', path: '/mentions/mark-resolved' },
} as const
